﻿import dayjs from 'lib/dayjs';
import UnplannedDatesCell from 'components/ui/UnplannedDatesCell';
import { getUnplannedDates, getUnplannedState } from 'utils/unplanned';
import Icon from '../../../components/AppIcon';

const UnplannedLeaveTable = ({
  leaves,
  isLoading,
  onAddLeave,
  onAddLog,
  onApprove,
  onReject,
  isDashboard,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!leaves || leaves.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-text-secondary">
        <Icon name="FileText" size={48} className="mb-4 opacity-20" />
        <p className="text-lg font-medium">No unplanned leaves found</p>
      </div>
    );
  }

  const headerClass =
    'px-6 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider';

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-border border-b">
        <thead className="bg-secondary-50">
          <tr>
            <th className={headerClass}>Date</th>
            <th className={headerClass}>Employee ID</th>
            <th className={headerClass}>Name</th>
            {!isDashboard && <th className={headerClass}>Status</th>}
            {!isDashboard && <th className={headerClass}>Reason</th>}
            {onAddLeave && <th className={headerClass}>Action</th>}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-border">
          {leaves.map((leave) => {
            const dates = getUnplannedDates(leave);
            const state = getUnplannedState(leave);
            return (
              <tr key={leave.id} className="hover:bg-secondary-100 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-text-secondary">
                  {isDashboard ? (
                    dayjs(leave.date).format('DD MMM, YYYY')
                  ) : (
                    <UnplannedDatesCell dates={dates} className="text-text-primary" />
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-text-secondary">
                  {leave.user?.employee_id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-text-secondary">
                  {leave.user?.first_name} {leave.user?.last_name}
                </td>
                {!isDashboard && (
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${state.tone}`}
                    >
                      {state.label}
                    </span>
                  </td>
                )}
                {!isDashboard && (
                  <td className="max-w-xs truncate px-6 py-4 text-sm text-text-secondary">
                    {leave.leave_request?.reason || '—'}
                  </td>
                )}
                {onAddLeave && (
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {state.key === 'waiting' && onApprove ? (
                      <div className="flex gap-2">
                        <button
                          onClick={() => onApprove(leave.leave_request)}
                          className="px-3 py-1.5 bg-green-100 text-green-700 hover:bg-green-200 text-xs font-medium rounded-md transition-colors duration-200"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => onReject?.(leave.leave_request)}
                          className="px-3 py-1.5 bg-red-100 text-red-700 hover:bg-red-200 text-xs font-medium rounded-md transition-colors duration-200"
                        >
                          Reject
                        </button>
                      </div>
                    ) : state.key === 'action' ? (
                      <div className="flex gap-2">
                        <button
                          onClick={() => onAddLeave(leave)}
                          className="px-3 py-1.5 bg-primary-100 text-primary hover:bg-primary-200 text-xs font-medium rounded-md transition-colors duration-200"
                        >
                          Add Leave
                        </button>
                        {onAddLog && (
                          <button
                            onClick={() => onAddLog(leave)}
                            className="px-3 py-1.5 border border-border text-text-secondary hover:bg-secondary-100 text-xs font-medium rounded-md transition-colors duration-200"
                          >
                            Add Log
                          </button>
                        )}
                      </div>
                    ) : (
                      <span className="text-text-secondary">—</span>
                    )}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UnplannedLeaveTable;
